/* ==========================================================================
   Marketing Footer
   Task F33: Shared footer for all standalone (non-portal) pages
   ========================================================================== */

export function MarketingFooter() {
  return (
    <footer className="py-8 border-t border-charcoal/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="font-serif text-lg text-charcoal/70">
            TJM Labs
          </span>
          <p className="text-sm text-charcoal/50">
            &copy; {new Date().getFullYear()} TJM Labs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default MarketingFooter
